import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import Modal from "./Modal";
import MiniLoader from "./MiniLoader";
import UserAvatar from "./UserAvatar";
import * as actions_bidder from "../redux/actions/adBidderActions";
import * as actions_transaction from "../redux/actions/transactionRequestPendingActions";
import "./styles/ModalAuctionBid.css";

class ModalAuctionBid extends React.Component {
  state = {
    amount: "",
    submitting: false,
    submitted: false,
    localError: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.resetForm();
      this.loadTopOffers();
    }
  }

  getDefaultBidAmount = () => {
    const price = Number(this.props.ad?.Price);
    if (!Number.isNaN(price) && price > 0) {
      return String(price);
    }
    return "1";
  };

  resetForm = () => {
    this.setState({
      amount: this.getDefaultBidAmount(),
      submitting: false,
      submitted: false,
      localError: "",
    });
  };

  loadTopOffers = async () => {
    if (!this.props.ad?.Id || !this.props.token) return;

    try {
      await this.props.LoadAdBidder(
        this.props.ad.Id,
        this.props.user_id,
        this.props.token
      );
    } catch (error) {
      console.log(error);
    }
  };

  onClose = () => {
    this.resetForm();
    this.props.onClose();
  };

  onChangeAmount = (event) => {
    this.setState({
      amount: event.target.value,
      localError: "",
    });
  };

  onSubmit = async (event) => {
    event.preventDefault();

    if (!this.props.user_id) {
      this.setState({ localError: "warning_login" });
      return;
    }

    const amount = Number(this.state.amount);
    if (!this.state.amount || Number.isNaN(amount) || amount < 1) {
      this.setState({ localError: "auction_bid_min_error" });
      return;
    }

    const params = new FormData();
    params.append("goder_id", this.props.ad.Id);
    params.append("message", "");
    params.append("quantity", String(amount));
    params.append("price", String(amount));
    params.append("id", this.props.user_id);

    this.setState({ submitting: true, localError: "" });

    try {
      const result = await this.props.NewTransaction(this.props.token, params);

      if (!result?.success) {
        this.setState({
          submitting: false,
          localError: result?.error || this.props.error_transaction || "try_later",
        });
        return;
      }

      await this.loadTopOffers();
      this.setState({ submitting: false, submitted: true });
      if (this.props.onBidSuccess) {
        this.props.onBidSuccess();
      }
    } catch (error) {
      console.log(error);
      this.setState({ submitting: false, localError: "try_later" });
    }
  };

  renderTopOffers() {
    const { loading, list, ad } = this.props;
    const currency = ad?.Currency || "USD";
    const topOffers = (list || []).slice(0, 5);

    if (loading) {
      return (
        <div className="auction-bid-modal__loader">
          <MiniLoader />
        </div>
      );
    }

    if (topOffers.length === 0) {
      return (
        <p className="auction-bid-modal__empty">
          <Translate value="auction_bid_empty_offers" />
        </p>
      );
    }

    return (
      <ol className="auction-bid-modal__offers">
        {topOffers.map((item, index) => (
          <li key={item.Id} className="auction-bid-modal__offer">
            <span className="auction-bid-modal__offer-rank">#{index + 1}</span>
            <div className="auction-bid-modal__offer-user">
              <UserAvatar
                src={item.User?.Avatar}
                alt={item.User?.Name || ""}
                user={item.User}
                size="sm"
                className="auction-bid-modal__offer-avatar-wrap"
              />
              <span className="auction-bid-modal__offer-name">
                {item.User?.Name || "—"}
              </span>
            </div>
            <span className="auction-bid-modal__offer-price">
              {item.Price} {currency}
            </span>
          </li>
        ))}
      </ol>
    );
  }

  renderForm() {
    const { ad } = this.props;
    const currency = ad?.Currency || "USD";
    const defaultAmount = this.getDefaultBidAmount();

    return (
      <form className="auction-bid-modal__form" onSubmit={this.onSubmit}>
        <section className="auction-bid-modal__section">
          <label className="auction-bid-modal__label" htmlFor="auction-bid-amount">
            <Translate value="auction_bid_amount_label" />
          </label>
          <div className="auction-bid-modal__amount-wrap">
            <input
              id="auction-bid-amount"
              type="number"
              min="1"
              step="0.01"
              className="auction-bid-modal__input"
              value={this.state.amount}
              onChange={this.onChangeAmount}
              placeholder={defaultAmount}
              disabled={this.state.submitting}
            />
            <span className="auction-bid-modal__currency">{currency}</span>
          </div>
          <p className="auction-bid-modal__hint">
            <Translate value="auction_bid_amount_hint" />
          </p>
        </section>

        <section className="auction-bid-modal__section">
          <h3 className="auction-bid-modal__section-title">
            <Translate value="auction_bid_top_offers" />
          </h3>
          {this.renderTopOffers()}
        </section>

        {this.state.localError && (
          <p className="auction-bid-modal__error">
            {I18n.t(this.state.localError)}
          </p>
        )}

        <div className="auction-bid-modal__actions">
          <button
            type="button"
            className="auction-bid-modal__btn auction-bid-modal__btn--secondary"
            onClick={this.onClose}
            disabled={this.state.submitting}
          >
            <Translate value="profile_configuration_delete_cancel" />
          </button>
          <button
            type="submit"
            className="auction-bid-modal__btn auction-bid-modal__btn--primary"
            disabled={this.state.submitting}
          >
            {this.state.submitting ? (
              <Translate value="auction_bid_submitting" />
            ) : (
              <Translate value="auction_bid_submit" />
            )}
          </button>
        </div>
      </form>
    );
  }

  renderSuccess() {
    return (
      <div className="auction-bid-modal__success">
        <h3 className="auction-bid-modal__success-title">
          <Translate value="auction_bid_success_title" />
        </h3>
        <p className="auction-bid-modal__success-text">
          <Translate value="auction_bid_success_message" />
        </p>
        <button
          type="button"
          className="auction-bid-modal__btn auction-bid-modal__btn--primary"
          onClick={this.onClose}
        >
          <Translate value="ok" />
        </button>
      </div>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.onClose}
        title={<Translate value="ad_bid" />}
      >
        <div className="auction-bid-modal">
          {this.state.submitted ? this.renderSuccess() : this.renderForm()}
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    list: reducer.adBidder.list,
    loading: reducer.adBidder.loading,
    error_transaction: reducer.transactionRequestPending.error_new,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadAdBidder: (id, user_id, token) =>
    dispatch(actions_bidder.loadList({ id, user_id, token })),
  NewTransaction: (token, params) =>
    dispatch(actions_transaction.newItem({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalAuctionBid);
